import { AnyAction, createSlice, PayloadAction, ThunkAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../../app/store';
import { openSnackbar } from '../../features/snackbar/globalSnackbarSlice';
import { getWithAuth, postJsonWithAuth, putWithAuth } from '../../utils/api';
import { konfig } from '../../utils/apiTypes';
import { errorHandler } from '../../utils/errorHandling';
import { logError } from '../../utils/utils';
import { konfigurationState } from './konfigurationTypes';

const konfigDummy: konfig = {
    id: 0,
    kategorie: "",
    name: "",
    wert: "true",
    default: true,
}

const initialState: konfigurationState = {
    isUTC: false,
    konfig: konfigDummy,
}

const konfigurationSlice = createSlice({
    name: "konfiguration",
    initialState,
    reducers: {
        setDateKonfig: (state, action: PayloadAction<string>) => {
            state.konfig.wert = action.payload;
        },
        setKonfigId: (state, action: PayloadAction<number>) => {
            state.konfig.id = action.payload;
        },
        setKonfig: (state, action: PayloadAction<konfig>) => {
            state.konfig = action.payload;
        },

    }
});

export const {
    setDateKonfig,
    setKonfigId,
    setKonfig
} = konfigurationSlice.actions

export const selectDateKonfig = (state: RootState): konfig => state.konfiguration.konfig;
export const selectDate = (state: RootState): boolean => state.konfiguration.konfig.wert == "false" ? false : true;

export const getKonfig = () => (dispatch: AppDispatch): void => {
    getWithAuth("KONFIG", { name: "ist_utc", kategorie: "konfig" })
        .then((response: konfig[]) => {
            const sortedResponse = response.sort((a, b) => (a.id > b.id) ? 1 : -1);
            dispatch(setKonfig(sortedResponse[sortedResponse.length - 1]));
        })
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        });
};

export const updateKonfig = (konfig: konfig, wert: string): ThunkAction<void, RootState, unknown, AnyAction> => (
    dispatch: AppDispatch
) => {
    const konfigTemp: konfig = {
        id: konfig.id,
        kategorie: konfig.kategorie,
        name: konfig.name,
        wert: wert,
        default: konfig.default,
    }
    dispatch(setDateKonfig(wert));
    if (konfigTemp.default) {
        postJsonWithAuth("KONFIG", {}, konfigTemp)
            .then((response: number) => {
                konfigTemp.id = response;
                konfigTemp.default = false;
                dispatch(setKonfig(konfigTemp));
                dispatch(
                    openSnackbar({
                        message: `Uhrzeitdarstellung wurde geändert.`,
                        severity: "success",
                        duration: 6000,
                    })
                );
            })
            .catch((error) => {
                dispatch(setDateKonfig(konfig.wert));
                logError(error);
                errorHandler(error, dispatch);
            })
    } else {
        putWithAuth("KONFIGID", {}, konfigTemp, konfigTemp.id.toString())
            .then(() => {
                dispatch(
                    openSnackbar({
                        message: `Uhrzeitdarstellung wurde geändert.`,
                        severity: "success",
                        duration: 6000,
                    })
                );
            })
            .catch((error) => {
                dispatch(setDateKonfig(konfig.wert));
                logError(error);
                errorHandler(error, dispatch)
            });
    }
};

export default konfigurationSlice.reducer